// `me` / `targets` come from GET /api/dashboard/staff-targets.
// Team rows (`own` / `team_total`) come from GET /api/dashboard/staff-targets/team.
export const STAFF_TARGET_METRICS = [
  { key: 'lead_emails', label: 'Daily Lead Emails Sent', shortLabel: 'Lead emails', period: 'today' },
  { key: 'publishes', label: 'Daily Publish Tracker', shortLabel: 'Publishes', period: 'today' },
  { key: 'projects', label: 'Daily New Projects Created', shortLabel: 'New projects', period: 'today' },
  { key: 'scheduled_calls', label: 'Monthly Scheduled Calls', shortLabel: 'Scheduled calls (month)', rangeLabel: 'Scheduled calls', period: 'this month' },
  { key: 'credits', label: 'Monthly Credit', shortLabel: 'Credit (month)', rangeLabel: 'Credit', period: 'this month' }
]

export function formatMetric(key, value) {
  return key === 'credits' ? Number(Number(value || 0).toFixed(2)) : (value || 0)
}
